import { PuzzlePieceIcon } from '@heroicons/react/24/outline';
import { useLocation } from 'react-router-dom';
import { MultiSelect } from '../multi-select';
import { ProviderImage } from '../provider-image';
import { SkeletonLoader } from '../skeleton-loader';
import { FilterControls, IntegrationFilter } from './filter-types';

export const IntegrationFilterFC = ({
  error,
  data,
  id,
  label,
  loading,
  value,
  filters,
  onClose,
  filteredValues,
  setValue,
  placement,
  displayMaxItems,
  selectText,
  permanent,
  showInlineClear,
  hideIcon,
  showOperator,
  wrapperClassName,
  dataTestId,
}: IntegrationFilter & FilterControls) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const integrationIdsParam = queryParams.get('integrationIds');
  const initialIntegrations =
    integrationIdsParam && integrationIdsParam.split(',').length > 0
      ? integrationIdsParam.split(',')
      : [];
  const provider = filters.find((filter) => filter.type === 'provider')?.id;
  const providerValues =
    provider && filteredValues
      ? (filteredValues[provider] as string[]) || []
      : [];

  return (
    <SkeletonLoader
      status={loading ? 'loading' : error ? 'error' : 'success'}
      error={error}
      type="line"
      key={id}
    >
      <MultiSelect
        dataTestId={dataTestId}
        label={label}
        showOperator={showOperator}
        displayButtonClassName={wrapperClassName}
        options={
          data
            ?.filter((int) => {
              return (
                !providerValues.length ||
                providerValues?.includes(int.provider || '') ||
                value.includes(int.integrationId || '')
              );
            })
            .map((int) => ({
              value: int.integrationId || '',
              searchString: `${int.name} ${int.integrationId} ${int.provider}`,
              label: (
                <div className="flex flex-col truncate">
                  <div className="flex items-center gap-1">
                    <ProviderImage
                      sizeClassName="w-8 h-6 flex-shrink-0"
                      provider={int.provider}
                    />
                    <div className="truncate">{int.name}</div>
                  </div>
                  {int.providerAccountId && (
                    <span className="inline-flex text-xs text-gray-600 dark:text-gray-400">
                      {int.providerAccountId}
                    </span>
                  )}
                </div>
              ),
              selectedDisplay: (
                <div className="flex items-center gap-1">
                  <ProviderImage
                    sizeClassName="w-8 h-6 flex-shrink-0"
                    provider={int.provider}
                  />
                  <div className="truncate">{int.name}</div>
                </div>
              ),
            })) || []
        }
        mode="multiple"
        icon={PuzzlePieceIcon as React.FC<{ className?: string }>}
        allowSearch
        showSelectAll
        value={value.length ? value : initialIntegrations}
        setValue={setValue}
        onClose={onClose}
        placement={placement}
        className={`h-[40px]`}
        displayMaxItems={displayMaxItems}
        selectText={selectText}
        permanent={permanent}
        showInlineClear={showInlineClear}
        hideIcon={hideIcon}
      />
    </SkeletonLoader>
  );
};
